// R8: a learned return-to-balance rate, NOT a second mood/damage meter.
// Event deltas always remain the user's fixed values. Recovery is a separate,
// visible movement of the same mood.value toward zero, in Resilience only.
export const RECOVERY_DELAY = 2.5;
export const POSITIVE_RECOVERY_DELAY = 8;
export const RECOVERY_BASE_RATE = .012;
export const RECOVERY_LEARNED_RATE = .072;
export function createResilience(saved={}) {
 saved=saved&&typeof saved==='object'?saved:{};
 const practice=Number.isFinite(saved.practice)?Math.max(0,Math.min(360,saved.practice)):0;
 return {practice,wait:Number.isFinite(saved.wait)?Math.max(0,Math.min(POSITIVE_RECOVERY_DELAY,saved.wait)):0,
  seenEvent:0,holdingPositive:Boolean(saved.holdingPositive),capacity:.92*(1-Math.exp(-practice/55)),recovering:false,rate:RECOVERY_BASE_RATE};
}
export function updateResilience(state,mood,{dt=0,mode='paths',engaged=false}={}) {
 dt=Math.max(0,Math.min(.1,Number.isFinite(dt)?dt:0));
 const changed=mood.eventId!==state.seenEvent;
 state.seenEvent=mood.eventId;
 state.recovering=false;
 if(changed&&mood.lastEvent){
  const event=mood.lastEvent;
  const positive=event.delta>0&&mood.value>=.2-1e-7;
  state.holdingPositive=positive;
  const delay=positive?POSITIVE_RECOVERY_DELAY:RECOVERY_DELAY;
  state.wait=Math.max(0,delay-Math.max(0,mood.time-event.time));
  if(mode==='resilience')state.practice+=event.delta<0?4:1.5;
 }
 // The event is felt immediately. Only passive settling waits; no immunity.
 // Delay time follows the same foreground clock across chapters, not scrolls.
 const available=changed?0:Math.max(0,dt-state.wait);
 if(!changed)state.wait=Math.max(0,state.wait-dt);
 if(state.wait<1e-7){state.wait=0;state.holdingPositive=false;}
 if(mode!=='resilience')return state;
 // Staying idle does not farm experience. Rest can still be restorative.
 if(engaged)state.practice+=dt;
 state.practice=Math.min(360,state.practice);
 state.capacity=.92*(1-Math.exp(-state.practice/55));
 state.rate=RECOVERY_BASE_RATE+RECOVERY_LEARNED_RATE*state.capacity;
 if(available>0&&Math.abs(mood.value)>1e-7){
  const before=mood.value;
  mood.value=Math.sign(before)*Math.max(0,Math.abs(before)-state.rate*available);
  if(Math.abs(mood.value)<1e-7)mood.value=0;
  state.recovering=mood.value!==before;
 }
 return state;
}
export function serializeResilience(state){return {practice:state.practice,wait:state.wait,holdingPositive:state.holdingPositive};}
